__turbopack_context__.v({
  "actions": "JB0Yqq_actions",
  "body": "JB0Yqq_body",
  "copy": "JB0Yqq_copy",
  "subtitle": "JB0Yqq_subtitle",
  "title": "JB0Yqq_title",
});
